import { format, parseISO, formatISO } from 'date-fns';
const DATE_TIME_FORMAT = "yyyy-MM-dd'T'HH:mm:ss.SSSxxx";
const START_OF_DAY = {
    HOURS: 0,
    MINUTES: 0,
    SECONDS: 0,
};
const END_OF_DAY = {
    HOURS: 23,
    MINUTES: 59,
    SECONDS: 59,
};
const toBoolean = (val) => {
    if (val === 'true') {
        return true;
    }
    if (val === 'false') {
        return false;
    }
    return val;
};
const sanitizeDateable = (value) => {
    var _a;
    if (typeof value !== 'object' ||
        Array.isArray(value) ||
        !((_a = value.start) !== null && _a !== void 0 ? _a : value.end)) {
        return value;
    }
    const result = Object.assign({}, value);
    if (value.start) {
        const startDate = parseISO(typeof value.start === 'string' ? value.start : formatISO(value.start));
        result.start = format(new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate(), START_OF_DAY.HOURS, START_OF_DAY.MINUTES, START_OF_DAY.SECONDS), DATE_TIME_FORMAT);
    }
    if (value.end) {
        const endDate = parseISO(typeof value.end === 'string' ? value.end : formatISO(value.end));
        result.end = format(new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate(), END_OF_DAY.HOURS, END_OF_DAY.MINUTES, END_OF_DAY.SECONDS), DATE_TIME_FORMAT);
    }
    return result;
};
const hasOptions = (filter) => {
    return 'options' in filter && !!filter.options;
};
const isSingleSelectFilter = (filter) => {
    return filter.type === 'select' || filter.type === 'search';
};
const isMultiSelectFilter = (filter) => {
    return filter.type === 'multiple' || filter.type === 'multiple-search';
};
export function filtersTransform(filters) {
    return ({ value }) => {
        if (typeof value !== 'object' || Array.isArray(value) || !value) {
            return value;
        }
        return Object.keys(value).reduce((acc, filter) => {
            const activeFilter = filters.find(({ key }) => key === filter);
            if (!activeFilter) {
                return acc;
            }
            let transformedValue = value[filter];
            if (activeFilter.type === 'bool') {
                transformedValue = toBoolean(value[filter]);
            }
            if (activeFilter.type === 'timerange') {
                transformedValue = sanitizeDateable(value[filter]);
            }
            if (isSingleSelectFilter(activeFilter) && hasOptions(activeFilter)) {
                const isValidOption = activeFilter.options.some(({ value: option }) => option === transformedValue);
                if (!isValidOption) {
                    return acc;
                }
            }
            if (isMultiSelectFilter(activeFilter) &&
                Array.isArray(transformedValue) &&
                hasOptions(activeFilter)) {
                const validValues = transformedValue.filter((val) => activeFilter.options.some(({ value: option }) => option === val));
                if (validValues.length === 0) {
                    return acc;
                }
                transformedValue = validValues;
            }
            return Object.assign(Object.assign({}, acc), { [filter]: transformedValue });
        }, {});
    };
}
